import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { structureList, delStructure, structureStatus } from './request';
import { customerList } from './../../system/customerManage/request';
import companyModel from './companyModel.vue';
import DeactivateModel from './deactivateModel.vue';
import { structureResource } from './../staffManage/request';
export default {
  components: {
    companyModel,
    DeactivateModel
  },
  data() {
    return {
      companyShow: false,
      deactivateShow: false,
      form: {
        customerId: '',
        structureId: undefined
      },
      customerList: [],
      resourceList: [],
      data: [],
      columns: [{
        dataIndex: 'name',
        key: 'name',
        slots: {
          title: '名称'
        },
        scopedSlots: {
          customRender: 'name'
        }
      }, {
        slots: {
          title: '架构图'
        },
        align: 'center',
        key: 'age',
        scopedSlots: {
          customRender: 'framework'
        },
        width: 200
      }, {
        slots: {
          title: '操作'
        },
        key: 'action',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        },
        width: 300
      }]
    };
  },
  created() {
    customerList({
      page: 1,
      pageSize: 10000
    }).then(res => {
      this.customerList = res.items;
      let arr = this.customerList.filter(item => item.id == Number(sessionStorage.getItem('customerId')));
      this.form.customerId = arr.length != 0 ? Number(sessionStorage.getItem('customerId')) : res.items[0].id;
      sessionStorage.setItem('customerId', this.form.customerId);
      this.getDataFun();
      this.getStructure();
    });
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    getStructure() {
      structureResource({
        customerId: this.form.customerId
      }).then(res2 => {
        this.resourceList = res2;
      });
    },
    getDataFun() {
      structureList(this.form).then(res => {
        console.log(res);
        this.data = res;
      });
    },
    customerIdFun(e) {
      this.data = [];
      sessionStorage.setItem('customerId', e);
      this.getDataFun();
      this.getStructure();
    },
    addDepartment(data, type) {
      this.companyShow = true;
      data.customerId = this.form.customerId;
      this.$nextTick(() => {
        this.$refs.companyForm.init(data, type);
      });
    },
    delDepartment(val) {
      let _this = this;
      this.$alert(this.$t('是否确认删除该架构') + '?', {
        confirmButtonText: this.$t('确定')
      }).then(() => {
        delStructure({
          customerId: _this.form.customerId,
          structureId: val.id
        }).then(res => {
          _this.$message.success(this.$t('删除成功'));
          _this.getDataFun();
        });
      });
    },
    handleDeactivate(val, type) {
      this.deactivateShow = true;
      val.customerId = this.form.customerId;
      this.$nextTick(() => {
        this.$refs.deactivateForm.init(val, type);
      });
    },
    handleEnable(val) {
      structureStatus({
        customerId: this.form.customerId,
        structureId: val.id,
        status: 1
      }).then(() => {
        this.$message.success(this.$t('操作成功'));
        this.getDataFun();
      });
    },
    goFrameworkFun(record) {
      if (!this.isAuth('home.companyStructureBranch')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      this.$router.push({
        name: 'framework',
        params: {
          id: record.id,
          customerId: this.form.customerId
        }
      });
    }
  }
};